<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="isCreate ? newRules: updateRules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>
              
            <div class="w-full" v-if="form.FechaBloqueo && role === 'SuperAdministrador'">
              <base-ro-input-minimal :label="$t('configurations.FechaBloqueo') + form.FechaBloqueo"/>
            </div>
            
            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">

              <div class="w-full" 
                v-if="role === 'SuperAdministrador' && 
                  (isCreate && (form.roleId == 5 || form.roleId == 6) || (!isCreate && form.idDistribuidor))
                  ">
                <div class="flex justify-between items-center">
                  <div class="flex-1">
                    <AccessibleElSelect
                      v-model="form.idDistribuidor"
                      prop="idDistribuidor"
                      :options="distribuidoresForAccessibleSelect"
                      clearable
                      :isDisabled="!isCreate"
                      id-prefix="user"
                    >
                      <template slot="label">
                        <base-obligatory-icon v-if="isCreate"/>
                        {{$t('distributors.distributor')}}
                      </template>
                    </AccessibleElSelect>
                  </div>
                  <base-button
                    v-if="!isCreate"
                    class="ml-4"
                    mode="primary"
                    :text="$t('app.detail')"
                    @click.prevent.stop="goDetailDistributor"
                    :loading="isGeneralLoading"
                  />
                </div>
              </div>

              <div class="w-full" 
                v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador') &&
                 (form.roleId !== 3 && form.roleId !== 5 && form.roleId !== 6)">
                <div class="flex justify-between items-center">
                  <div class="flex-1">
                    <AccessibleElSelect
                      v-model="form.clienteId"
                      prop="clienteId"
                      :options="clientesForAccessibleSelect"
                      clearable
                      :isDisabled="!isCreate"
                      id-prefix="user"
                    >
                      <template slot="label">
                        <base-obligatory-icon v-if="isCreate"/>
                        {{$t('app.client')}}
                      </template>
                    </AccessibleElSelect>
                  </div>
                  <base-button
                    v-if="!isCreate"
                    class="ml-4"
                    mode="primary"
                    :text="$t('app.detail')"
                    @click.prevent.stop="goDetailClient"
                    :loading="isGeneralLoading"
                  />
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('configurations.username')}}
                  <el-form-item prop="name">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.name"
                      maxlength='50'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('configurations.email')}}
                  <el-form-item prop="email">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.email"
                      maxlength='255'
                      autocomplete="email"
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.roleId"
                prop="roleId"
                :options="rolesForAccessibleSelect"
                :isDisabled="isSameUser"
                id-prefix="user"
              >
                <template slot="label">
                  <base-obligatory-icon/>
                  {{$t('configurations.rol')}}
                </template>
              </AccessibleElSelect>
            </div>
            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.tipoAuth"
                prop="tipoAuth"
                :options="tiposAuthForAccessibleSelect"
                clearable
                :isDisabled="isSameUser"
                id-prefix="user"
              >
                <template slot="label">
                  <base-obligatory-icon/>
                  {{$t('configurations.tipo_auth')}}
                </template>
              </AccessibleElSelect>
            </div>

            <div 
              v-if="form.roleId !== 5"
              class="mb-2 lg:mb-4">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <!-- <el-checkbox class="text-base font-semibold text-secondary-600 block mb-1" :disabled="isSameUser && isRoleUserOrConsulta" v-model="form.verTodoStatuses">{{$t('configurations.ver_todo_statuses')}}</el-checkbox> -->
                  <label for="switch-ver-todo-statuses" class="sr-only">
                    {{$t('configurations.ver_todo_statuses')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-ver-todo-statuses"
                    :aria-label="$t('configurations.ver_todo_statuses')"
                    class="switch-text break-normal" 
                    :disabled="(isSameUser && isRoleUserOrConsulta) || form.roleId === 3 || form.roleId === 6 || !hasPermissionEditVisiblity" 
                    v-model="form.verTodoStatuses" 
                    :active-text="$t('configurations.ver_todo_statuses')">
                    </el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <!-- <el-checkbox class="text-base font-semibold text-secondary-600 block mb-1" :disabled="isSameUser && isRoleUserOrConsulta" v-model="form.verTodoCompanies">{{$t('configurations.ver_todo_companies')}}</el-checkbox> -->
                  <label for="switch-ver-todo-companies" class="sr-only">
                    {{$t('configurations.ver_todo_companies')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-ver-todo-companies"
                    :aria-label="$t('configurations.ver_todo_companies')"
                    class="switch-text break-normal" 
                    :disabled="(isSameUser && isRoleUserOrConsulta) || form.roleId === 3 || form.roleId === 6 || !hasPermissionEditVisiblity" 
                    v-model="form.verTodoCompanies" 
                    :active-text="$t('configurations.ver_todo_companies')">
                    </el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1"/>
                </div>
              </div>
            </div>

            <div class="mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="switch-activo" class="sr-only">
                    {{$t('app.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-activo"
                    :aria-label="$t('app.active')"
                    class="switch-text break-normal" 
                    :disabled="isSameUser || isRoleUserOrConsulta" 
                    v-model="form.Activo" 
                    :active-text="$t('app.active')">
                  </el-switch>
                </div>
              </div>
            </div>

            <div class="mb-2 lg:mb-6" v-if="hasModuleDobleFactor && !isCreate && form.tipoAuth !== 1 && this.form.tipoAuth !== 3">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="mb-4 lg:mb-0 w-full">
                  <label for="switch-doble-factor" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('configurations.client_config_otp')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  </label>
                  <el-switch 
                    id="switch-doble-factor"
                    :aria-label="$t('configurations.client_config_otp')"
                    class="switch-text break-normal both-switch mt-2" 
                    v-model="form.DobleFactor"
                    :disabled="form.BloqueadoDobleFactor"
                    :active-text="$t('app.active')" 
                  />
                </div>
              </div>
            </div>

            <div class="lg:mb-4">
              <div v-if="isCreate" class="lg:mb-2">
                <base-password-form-item v-if="this.form.tipoAuth !== 1 && this.form.tipoAuth !== 3"
                   v-model="form.password" autocomplete="new-password" />
                <base-password-form-item v-if="this.form.tipoAuth !== 1 && this.form.tipoAuth !== 3"
                   v-model="form.repeat_password" :password="form.password" autocomplete="new-password" repeat />
              </div>
            </div>
            <div class="lg:mb-2">
              <div v-if="!isCreate && form.created_at" class="mandatory">
                <base-ro-input
                  :label="$t('configurations.created_at')"
                  :data="form.created_at"
                />
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            v-if="form.FechaBloqueo && role === 'SuperAdministrador'"
            mode="primary"
            :text="'Desbloquear usuario'"
            icon="unlock"
            @click="unlockUserHandler()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isCreate"
            mode="primary"
            :text="'Email recuperación de contraseña'"
            icon="lock"
            @click="recoveryPassHandler()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="hasModuleDobleFactor && !isCreate && form.tipoAuth !== 1"
            mode="primary"
            :text="'Restablecer autenticación en dos pasos'"
            icon="retrydoblefactor"
            @click="resetOTPHandler()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="save"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <user-generate-password-dialog
        :dialogOpen="showGeneratePassword"
        :email="this.$route.params.id"
        @toggleDialog="toggleDialogs"
      />

    </template>
  </detail-layout>
</template>

<script>
import moment from 'moment'
import { bus } from '@/main'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { getClients } from '@/services/clients/getClients'
import { getUser } from '@/services/configurations/getUser'
import { newUser } from '@/services/configurations/newUser'
import { updateUser } from '@/services/configurations/updateUser'
import { i18n } from '@/i18n'
import UserGeneratePasswordDialog from '@/components/UserGeneratePasswordDialog.vue'
import { email as emailRegex } from '@/utils/regex'
import { ROLES } from '@/config/roles'
import { TIPOS_AUTH } from '@/config/tipos-auth'
import { getDistributors } from '@/services/distributors/getDistributors'
import { recoveryPassUsers } from '@/services/configurations/recoveryPassUsers'
import { resetOTP } from '@/services/configurations/resetOTP' 
import { desbloquearusuarios } from '@/services/configurations/desbloquearusuarios' 

export default {
  /* eslint-disable camelcase */
  name: 'user-detail',
  components: {
    DetailLayout,
    AccessibleElSelect,
    UserGeneratePasswordDialog
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      distribuidores: [],
      header: {
        title: 'DETALLE DE USUARIO',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/users'
      },
      loadedFirstTime: false,
      form: this.getDefaultForm(),
      clientes: [],
      tiposAuth: TIPOS_AUTH,
      // tooltipverTodoGroups: this.$i18n.t('tooltip.ver_todo_groups'),
      tooltipVerTodoStatuses: this.$i18n.t('tooltip.ver_todo_statuses'),
      tooltipVerTodoCompanies: this.$i18n.t('tooltip.ver_todo_companies'),
      toolAccesoAAD: this.$i18n.t('tooltip.acceso_AAD'),
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      updateRules: {
        name: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        email: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        roleId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        tipoAuth: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
      },
      newRules: {
        clienteId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' },
        ],
        name: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        email: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        roleId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' },
        ],
        tipoAuth: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' },
        ],
      }
    }
  },
  computed: {
    empresaFilter () {
      return this.isCreate ? this.$store.getters['users/getMasterFilters']?.empresa?.value || null : null
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    hasPermissionEditVisiblity () {
      return this.$store.getters['auth/hasPermissionEditVisiblity']
    },
    hasModuleDobleFactor () {
      return this.$store.getters['auth/hasModuleDobleFactor']
    },
    roles: function () {
      // Roles dependiendo del rol del usuario autenticado
      const rolesFilter = ROLES.filter(r => {
        if (r.only) {
          return r.only.includes(this.role)
        }
        return true
      })
      // Al crear o mientras carga la vista sin usuario, permitimos todos
      if (this.isCreate || !this.form.roleId) {
        return rolesFilter
      }
      // Rol SuperAdministrador
      if (this.form.roleId === 3) {
        return rolesFilter.filter(x => x.id === 3)
      }
      const rolesDistributor = [5, 6]
      // Rol SuperAdminDistribuidor o AdminDistribuidor
      if (rolesDistributor.includes(this.form.roleId)) {
        return rolesFilter.filter(x => rolesDistributor.includes(x.id))
      } 
      // Rol Adminisitrador, Usuario o UsuarioConsulta
      return rolesFilter.filter(x => !rolesDistributor.includes(x.id) && x.id !==3)
    },
    id: function () {
      return this.$route.params.id
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
    getIdUsuarioLogged: function () {
      return this.$store.getters['auth/user'].IdUsuario
    },
    isSameUser: function () {
      return this.getIdUsuarioLogged === parseInt(this.id)
    },
    distribuidoresForAccessibleSelect () {
      return this.distribuidores.map(dist => ({
        id: dist.IdDistribuidor,
        value: dist.IdDistribuidor,
        name: dist.Nombre
      }))
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({
        id: cliente.IdEmpresa,
        value: cliente.IdEmpresa,
        name: cliente.Nombre
      }))
    },
    rolesForAccessibleSelect () {
      return this.roles.map(role => ({
        id: role.id,
        value: role.id,
        name: role.name
      }))
    },
    tiposAuthForAccessibleSelect () {
      return this.tiposAuth.map(tipo => ({
        id: tipo.id,
        value: tipo.id,
        name: tipo.name,
        disabled: tipo.disabled
      }))
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.roleId': {
      deep: true,
      immediate: true,
      handler: 'watchFormHandlerRole'
    },
  },
  created: async function () {
    const localUser = this.$store.getters['auth/user']
    this.localUserId = localUser.IdUsuario
    const breadcrumbs = []

    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    }

    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas
      if (this.isCreate) this.preSelectClient(this.form, 'clienteId')

      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    }

    if (!this.isCreate) {
      await this.downloadData(this.id)
      if (this.$route.params.noticeType !== undefined && this.$route.params.noticeType !== null && this.$route.params.noticeType !== '') {
        this.header.url = 'notices/usuariospasswordcaducar'
        breadcrumbs.push({ path: 'notices/usuariospasswordcaducar', name: this.$i18n.t('app.usuariospasswordcaducar') })
      } else {
        breadcrumbs.push({ path: 'configurations/users', name: this.$i18n.t('app.users') })
      }
      breadcrumbs.push({ path: '', name: this.form.name })
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    } else {
      breadcrumbs.push({
        path: '',
        name: this.$i18n.t('configurations.new_user')
      })
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted () {
    this.resetControlFormChanges()
  },
  methods: {
    unlockUserHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsUsuario: [this.id],
        }
        const response = await desbloquearusuarios(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          await this.downloadData(this.id)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    recoveryPassHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsUsuario: [this.id],
        }
        const response = await recoveryPassUsers(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    resetOTPHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsUsuario: [this.id],
        }
        const response = await resetOTP(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    getDefaultForm: function () {
      return {
        id: 2,
        name: '',
        email: '',
        company: '',
        active: false,
        idDistribuidor: null,
        created_at: '',
        password: '',
        repeat_password: '',
        clienteId: null,
        roleId: null,
        // verTodoGroups: true,
        verTodoStatuses: true,
        verTodoCompanies: true,
        Activo: true,
        FechaBloqueo: null,
        tipoAuth: null,

        DobleFactor: false,
        BloqueadoDobleFactor: false,
      }
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    goDetailDistributor () {
      const id = this.form.idDistribuidor
      this.$router.push({ name: 'configurations/distributors/details', params: { id } })
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    watchFormHandlerRole: function () {
      if (!this.loadedFirstTime) {
        if (this.form.roleId === 3 || this.form.roleId === 6) {
          if (this.form.verTodoStatuses === false || this.form.verTodoCompanies === false) {
            // this.form.verTodoGroups = true
            this.form.verTodoStatuses = true
            this.form.verTodoCompanies = true
          }
          this.doFeedback('Se han sobreescrito los permisos a los predeterminados por defecto para este rol', 'info')
        }
      }
    },
    toggleDialogs: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      if (!emailRegex.test(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        this.newUserHandler(formName)
      } else {
        this.updateUserHandler(formName)
      }
    },
    newUserHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            Nombre: this.form.name,
            Email: this.form.email,
            Password: this.form.password,
            idDistribuidor: this.form.idDistribuidor,
            idRol: this.form.roleId,
            idEmpresa: this.form.clienteId,
            VerTodoEstados: this.form.verTodoStatuses,
            VerTodoEmpresas: this.form.verTodoCompanies,
            Activo: this.form.Activo,
            idTipoAutenticacion: this.form.tipoAuth,
            IdCifs: []
          }
          const response = await newUser(params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
            this.resetControlFormChanges()
            if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
              this.preSelectClient(this.form, 'clienteId')
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    updateUserHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            idUsuario: this.form.id,
            Email: this.form.email,
            Nombre: this.form.name,
            VerTodoEstados: this.form.verTodoStatuses,
            VerTodoEmpresas: this.form.verTodoCompanies,
            Activo: this.form.Activo,
            idTipoAutenticacion: this.form.tipoAuth,
            idRol: this.form.roleId,
            DobleFactor: this.form.DobleFactor,
          }
          const response = await updateUser(params)
          if (response.blnError === false) {
            this.disableRoutes()
            this.doFeedback('Datos guardados correctamente', 'success')
            this.updateView()
            this.resetControlFormChanges()
          } else {
            this.doFeedback(response.msgError)
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    disableRoutes: function () {
      const isDisabledByRol = (this.form.roleId === 3 || this.form.roleId === 5 || this.form.roleId === 6)
      const objDisableRoutes = {
        disableGroups: isDisabledByRol,
        disableStatuses: this.form.verTodoStatuses || isDisabledByRol,
        disableCompanies: this.form.verTodoCompanies || isDisabledByRol,
      }
      bus.$emit('disableOptionsUser', objDisableRoutes)
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/users' })
    },
    downloadData: async function (id) {
      let user = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idUsuario: id
        }
        user = await getUser(params)
        this.setUser(user.respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return user
    },
    setUser: function (user) {
      const role = this.roles.find(r => r.name === user.Rol)
      this.form.id = user.IdUsuario
      this.form.name = user.Usuario
      this.form.email = user.Email
      this.form.company = user.Empresa
      this.form.active = user.active
      this.form.created_at = user.created_at
      this.form.roleId = role ? role.id : null
      this.form.clienteId = user.idEmpresa
      this.form.verTodoStatuses = user.VerTodoEstados
      this.form.verTodoCompanies = user.VerTodoEmpresas
      this.form.DobleFactor = user.DobleFactor
      this.form.BloqueadoDobleFactor = user.BloqueadoDobleFactor
      this.form.Activo = user.Activo
      this.form.FechaBloqueo = user.FechaBloqueo ? moment(user.FechaBloqueo).format('YYYY-MM-DD HH:mm') : null
      this.form.tipoAuth = user.idTipoAutenticacion
      this.form.idDistribuidor = user.idDistribuidor
      this.disableRoutes()
      this.loadedFirstTime = true
      this.resetControlFormChanges()
    },
    generatePassword: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
